import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { browserHistory } from 'react-router';
import humanize from 'humanize-string';
import styled from 'styled-components';

import MessageForm from './MessageForm';
import MessageList from './MessageList';
import SubmitButton from './SubmitButton';

import { createMessage, fetchMessages } from '../actions';
import { triggerTypes } from 'dash-front/triggerConstants';

import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import { Card, CardHeader } from 'material-ui/Card';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MessageIcon from 'material-ui/svg-icons/communication/message';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import { indigo500, grey300 } from 'material-ui/styles/colors';

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const Title = styled.h2`
    color: ${indigo500};
    font-weight: inherit;

    svg {
        margin-right: 10px;
        transform: translate(0, 4px);
    }
`;

const ButtonWrapper = styled.div`
    display: inline-block;
    flex-grow: 1;
    text-align: right;

    button {
        color: #fff;
    }
`;

const CreateMessage = reduxForm({
    form: 'createMessage',
    asyncBlurFields: [],
    onSubmit: (values, dispatch) => dispatch(createMessage(values))
})(MessageForm);

const triggerTypeNames = triggerTypes.map(t => t.trigger);

const getTrigger = trigger => {
    if (typeof trigger === 'string') {
        const lower = trigger.toLowerCase();

        return lower !== 'all' ? lower : null;
    }

    return null;
};

class MessageScene extends PureComponent {
    componentDidMount() {
        const { query } = browserHistory.getCurrentLocation();
        this.updateValues(query);
    }

    componentWillReceiveProps({ location }) {
        if (this.props.location !== location) {
            this.updateValues(location ? location.query : {});
        }
    }

    state = {
        showCreate: false,
        snackbarText: '',
        trigger: null
    };

    updateValues = query => {
        const { dispatch } = this.props;
        const trigger = getTrigger(query.trigger);

        dispatch(fetchMessages(trigger));

        this.setState({ trigger: trigger });
    };

    onTriggerChange = trigger => {
        browserHistory.push({
            pathname: window.location.pathname,
            query: {
                trigger: trigger ? trigger : 'all'
            }
        });
    };

    onCreateSuccess = result => {
        this.setState({ showCreate: false });
        const {
            body: { title }
        } = result;
        this.setState({ snackbarText: `Message ${title} was created` });
        setTimeout(() => {
            this.setState({ snackbarText: '' });
        }, 2000);
    };

    toggleCreate = () => this.setState(({ showCreate }) => ({ showCreate: !showCreate }));

    render() {
        const { showCreate, trigger, snackbarText } = this.state;

        return (
            <div>
                <Card>
                    <CardHeader
                        style={{
                            borderBottom: `1px solid ${grey300}`,
                            paddingTop: 0,
                            paddingBottom: 0
                        }}
                    >
                        <HeaderWrapper>
                            <Title>
                                <MessageIcon style={{ color: 'inherit' }} />Social Messages
                            </Title>
                            <SelectField
                                value={trigger}
                                style={{ marginLeft: 24 }}
                                underlineStyle={{ display: 'none' }}
                                dropDownMenuProps={{
                                    iconButton: <FilterIcon />,
                                    iconStyle: {
                                        top: -1,
                                        right: 'auto',
                                        left: 0,
                                        padding: '0',
                                        textAlign: 'left',
                                        fill: 'inherit'
                                    }
                                }}
                                labelStyle={{ paddingLeft: 30, paddingRight: 0 }}
                            >
                                {triggerTypeNames.map(name => (
                                    <MenuItem
                                        key={name}
                                        primaryText={humanize(name)}
                                        value={name}
                                        onTouchTap={() => this.onTriggerChange(name)}
                                    />
                                ))}
                                <MenuItem
                                    value={null}
                                    primaryText="All"
                                    onTouchTap={() => this.onTriggerChange(null)}
                                />
                            </SelectField>
                            <ButtonWrapper>
                                <RaisedButton onTouchTap={this.toggleCreate} secondary labelColor="#fff">
                                    Create
                                </RaisedButton>
                            </ButtonWrapper>
                        </HeaderWrapper>
                    </CardHeader>
                    <MessageList trigger={trigger} />
                </Card>
                <Dialog
                    open={showCreate}
                    autoScrollBodyContent
                    autoDetectWindowHeight
                    onRequestClose={this.toggleCreate}
                >
                    <CreateMessage onSubmitSuccess={this.onCreateSuccess} />
                    <div style={{ marginTop: 30, display: 'flex' }}>
                        <SubmitButton form="createMessage" label="Create" primary />
                        <ButtonWrapper>
                            <RaisedButton
                                onTouchTap={this.toggleCreate}
                                secondary
                                labelColor="#fff"
                                style={{ marginLeft: 30 }}
                            >
                                Cancel
                            </RaisedButton>
                        </ButtonWrapper>
                    </div>
                </Dialog>
                <Snackbar open={Boolean(snackbarText)} message={snackbarText} />
            </div>
        );
    }
}

MessageScene.propTypes = {
    location: PropTypes.object,
    dispatch: PropTypes.func
};

export default connect(state => ({ location: state.routing.location }))(MessageScene);



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/MessageScene.js
 **/